import React from "react";
import { Link } from "react-router-dom";
import CTA from "../components/cta";
function PrivacyPolicy()
{
    return(
      <>
  <section
    className="flat-title-page mrg-0 boder-r-0 pdg-btm-60"
    style={{ backgroundImage: "url(images/img/banner-innerpages.jpg)" }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Privacy Policy</h1>
        <ul className="breadcrumb">
          <li>
            <a href="/" className="text-white">
              Home
            </a>
          </li>
          <li className="text-white">/Privacy Policy</li>
        </ul>
      </div>
    </div>
  </section>
  <section className="flat-section">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="wow fadeInUp" style={{ visibility: "visible" }}>
          <h3 className="title mt-4">Privacy Policy – Nova Real Estate</h3>
          <p className="desc"></p>
          <h5 className="mb-15">General</h5>
          <p className="mb-15">
            a. This document is an electronic record under the Information
            Technology Act, 2000, and related rules, including amendments
            pertaining to electronic records. It is generated electronically and
            does not require physical or digital signatures.
            <br />
            b. This Privacy Policy is published in compliance with Rule 3(1) of
            the Information Technology (Intermediaries Guidelines) Rules, 2011,
            which requires publishing of the rules, regulations, Privacy Policy,
            and Terms of Use for access or usage of www.nvrealestate.ae
            (“Website”).
            <br />
            c. The Website www.nvrealestate.ae is owned and operated by Nova Real Estate. (“Company”), a private company incorporated under the
            provisions of the Companies Act, 2013. The term “Company” shall
            include its representatives, administrators, employees, directors,
            officers, agents, successors, and assigns.
            <br />
            d. This Privacy Policy becomes effective from the date and time a
            user registers with Nova Real Estate by providing details and accepting
            the Terms of Use and Privacy Policy.
          </p>
          <h5 className="mb-15">
            2. Collection of Personal and Other Information
          </h5>
          <p className="mb-15">
            a. To provide a personalized browsing experience, the Company may
            collect personal information from Users. Certain features of the
            Website may also require completion of a registration form or
            submission of specific details.
            <br />
            b. The User acknowledges that the Website may automatically track
            information such as IP address, browsing behavior, URLs visited
            before and after accessing the Website, computer and browser
            details, etc. This information is used for internal research on user
            demographics, interests, and behavior to better serve Users.
          </p>
          <h5 className="mb-15">3. Sharing of Personal Information</h5>
          <p className="mb-15">
            a. The Company may share User information with corporate entities
            and affiliates to:
          </p>
          <ul className="mb-15">
            <li>
              Detect and prevent fraud, identity theft, or other illegal
              activities.
            </li>
            <li>Correlate related accounts and prevent abuse of services.</li>
            <li>Facilitate joint or co-branded services where applicable.</li>
          </ul>
          <p>b. The Company may disclose User information:</p>
          <ul className="mb-15">
            <li>If required by law, court order, or legal process.</li>
            <li>
              To law enforcement, rights holders, or third parties if necessary
              to enforce Terms, respond to claims, or protect rights, property,
              or safety of Users or the public.
            </li>
          </ul>
          <h5 className="mb-15">4. User Responsibilities &amp; Consent</h5>
          <p className="mb-15">
            a. Users are solely responsible for maintaining the confidentiality
            of their login credentials and for all online/offline transactions
            conducted using their accounts, including those involving
            credit/debit cards or other instruments.
            <br />
            b. By using the Website and providing information, the User consents
            to the collection, storage, and use of their information as outlined
            in this Policy, including the sharing of such information in
            accordance with Section 3 above.
          </p>
          <h5 className="mb-15">5. Security</h5>
          <p className="mb-15">
            a. Transactions on the Website are secure. Information entered by
            Users during transactions is encrypted to prevent unauthorized
            access.
            <br />
            b. The Company does not receive or store Users’ credit/debit card
            details. Payment information is transmitted directly to authorized
            payment gateways, which comply with banking and payment industry
            regulations.
            <br />
            c. The Company assumes no responsibility for misuse of payment
            information by third-party gateways or intermediaries.
          </p>
          <h5 className="mb-15">6. Dispute Resolution &amp; Jurisdiction</h5>
          <p className="mb-15">
            a. Mediation: In case of a dispute, Parties shall first attempt to
            resolve the matter amicably within 30 days of one Party notifying
            the other.
            <br />
            b. Arbitration: If mediation fails, disputes will be referred to
            arbitration under a sole arbitrator appointed by the Company. The
            arbitration will be conducted in English, and the seat of
            arbitration shall be New Delhi, India. The arbitrator’s award will
            be final and binding on both Parties. Each Party shall bear its own
            costs unless otherwise directed by the arbitrator.
            <br />
            c. This Privacy Policy shall be governed by the laws of India, with
            exclusive jurisdiction of the courts at New Delhi.
          </p>
          <p />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default PrivacyPolicy;